var render = function render(){var _vm=this,_c=_vm._self._c;return _c('YLayoutBodyMenu',{attrs:{"menu":[
    {title:'基础配置',path:'/shop/plugin/knowledge/conf'},
    {title:'课程管理',path:'/shop/plugin/knowledge/course'},
    {title:'课程分类',path:'/shop/plugin/knowledge/cate'},
    {title:'讲师管理',path:'/shop/plugin/knowledge/teacher'},
]}},[_c('router-view')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }